import createAxiosInstance from './createAxiosInstance.js';
import content from './services/content/index.js';
import entitlement from './services/entitlement/index.js';
import experience from './services/experience/index.js';
import layout from './services/layout/index.js';
import customer from './services/customer/index.js';
import './interceptors/thinkAnalyticsParams.js';
import './services/content/types.js';
import './services/entitlement/v3/playback.js';
import './services/experience/types.js';
import './services/layout/types.js';
import 'axios';
import '@dtvgo/axios-interceptor-auth';
import '@dtvgo/axios-interceptor-client-headers';
import '@dtvgo/error';
import './interceptors/language.js';
import './services/content/v1/index.js';
import './services/content/v1/asset.js';
import './services/content/v1/shows.js';
import './services/content/v1/streaming.js';
import './services/content/v2/index.js';
import './services/content/v2/live.js';
import './services/content/v3/index.js';
import './services/content/v3/insight.js';
import './services/entitlement/v3/index.js';
import '@dtvgo/utils';
import './services/entitlement/types.js';
import './services/experience/v2/index.js';
import './services/experience/v2/learnActions.js';
import './services/experience/v3/index.js';
import './services/experience/v3/recommendation.js';
import './services/experience/v3/playback.js';
import './services/experience/v4/index.js';
import './services/experience/v4/playback.js';
import './services/experience/v4/recommendation.js';
import './services/experience/v4/learnActions.js';
import './services/layout/v3/index.js';
import './services/layout/v3/carousels.js';
import './services/layout/v3/pages.js';
import './services/layout/v4/index.js';
import './services/layout/v4/banner.js';
import './services/layout/v4/pages.js';
import './services/layout/v4/carousels.js';
import './services/layout/v5/index.js';
import './services/layout/v5/pages.js';
import './services/customer/v1/index.js';
import './services/customer/v1/profile.js';
import './services/customer/v1/accounts.js';
import './services/customer/v1/legal.js';

function createService(params) {
  const backendAxiosInstance = createAxiosInstance(params);
  return {
    content: content(backendAxiosInstance),
    customer: customer(backendAxiosInstance),
    entitlement: entitlement(backendAxiosInstance),
    experience: experience(backendAxiosInstance),
    layout: layout(backendAxiosInstance)
  };
}

export { createService as default };
//# sourceMappingURL=createService.js.map
